import "./styles.scss";

import { API, Endpoints } from "utils/api";
import { setLoader, setPagesModal } from "store/actions";

import { Modal } from "antd";
import React from "react";
import { connect } from "react-redux";
import { sanitizeHtml } from "utils/sanitizeHtml";
import { translate } from "utils/utils";

class PagesModal extends React.Component<any, any> {
	constructor(props: any) {
		super(props);

		this.state = {
			content: null,
			title: null,
			showModal: false
		};
	}

	componentDidMount() {
		const { dispatch } = this.props;
		dispatch(setPagesModal(""));
	}

	componentDidUpdate(prevProps: any) {
		const { pagesModal } = this.props;

		if (prevProps.pagesModal !== pagesModal || (prevProps.pagesModal && !this.state.showModal)) {
			if (!pagesModal) {
				this.setState({ showModal: false });
			} else {
				this.getData();
			}
		}
	}

	async getData() {
		const { dispatch, pagesModal } = this.props;

		dispatch(setLoader(true));

		let response: any;
		try {
			response = await API.get({
				url: Endpoints.uriPages(pagesModal)
			});

			if (response.ok) {
				const {
					pages: { content, title }
				} = response.data.results || {};
				this.setState({ showModal: true, content, title });
			} else {
			}
		} catch (err) {}

		dispatch(setLoader(false));
	}

	render() {
		const { showModal, content, title } = this.state;
		const { mobile, dispatch } = this.props;

		let size = mobile ? "100%" : 1200;
		if (window.innerWidth < 1200) size = "100%";

		return (
			<Modal
				centered={true}
				closable={true}
				visible={showModal}
				footer={null}
				className="PagesModalWrapper"
				width={size}
				onCancel={() => dispatch(setPagesModal(""))}
			>
				<div className="PagesModal">
					<div className="PagesModalTitle">
						<p>{translate(title)}</p>
					</div>
					<div
						className="PagesModalBody --boxed"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(String(translate(content) || "")) }}
					/>
				</div>
			</Modal>
		);
	}
}

const mapStateToProps = (state: any) => ({
	mobile: state.mobile,
	pagesModal: state.pagesModal
});

export default connect(mapStateToProps)(PagesModal);
